// Dunning Action Type

// Get Dunning List
export const GET_DUNNING_LIST = "GET_DUNNING_LIST";
export const GET_DUNNING_LIST_SUCCESS = "GET_DUNNING_LIST_SUCCESS";
export const GET_DUNNING_LIST_FAILURE = "GET_DUNNING_LIST_FAILURE";

// Dunning Action List
export const GET_DUNNING_ACTION_LIST = "GET_DUNNING_ACTION_LIST";
export const GET_DUNNING_ACTION_LIST_SUCCESS =
  "GET_DUNNING_ACTION_LIST_SUCCESS";
export const GET_DUNNING_ACTION_LIST_FAILURE =
  "GET_DUNNING_ACTION_LIST_FAILURE";

// Create Dunning Event
export const CREATE_DUNNING_EVENT = "CREATE_DUNNING_EVENT";
export const CREATE_DUNNING_EVENT_SUCCESS = "CREATE_DUNNING_EVENT_SUCCESS";
export const CREATE_DUNNING_EVENT_FAILURE = "CREATE_DUNNING_EVENT_FAILURE";

// Search Single Customer Dunning Event List
export const SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST =
  "SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST";
export const SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS =
  "SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_SUCCESS";
export const SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE =
  "SEARCH_SINGLE_CUSTOMER_DUNNING_EVENT_LIST_FAILURE";

// GET Dunning Single Event
export const GET_DUNNING_SINGLE_EVENT = "GET_DUNNING_SINGLE_EVENT";
export const GET_DUNNING_SINGLE_EVENT_SUCCESS =
  "GET_DUNNING_SINGLE_EVENT_SUCCESS";
export const GET_DUNNING_SINGLE_EVENT_FAILURE =
  "GET_DUNNING_SINGLE_EVENT_FAILURE";

// Create Dunning Event Action

// Update Dunning Event
export const UPDATE_DUNNING_EVENT = "UPDATE_DUNNING_EVENT";
export const UPDATE_DUNNING_EVENT_SUCCESS = "UPDATE_DUNNING_EVENT_SUCCESS";
export const UPDATE_DUNNING_EVENT_FAILURE = "UPDATE_DUNNING_EVENT_FAILURE";

// Delete Dunning Event
export const DELETE_DUNNING_EVENT = "DELETE_DUNNING_EVENT";
export const DELETE_DUNNING_EVENT_SUCCESS = "DELETE_DUNNING_EVENT_SUCCESS";
export const DELETE_DUNNING_EVENT_FAILURE = "DELETE_DUNNING_EVENT_FAILURE";

// Add New Dunning Event Action
export const ADD_NEW_DUNNING_EVENT_ACTION = "ADD_NEW_DUNNING_EVENT_ACTION";
export const ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS =
  "ADD_NEW_DUNNING_EVENT_ACTION_SUCCESS";
export const ADD_NEW_DUNNING_EVENT_ACTION_FAILURE =
  "ADD_NEW_DUNNING_EVENT_ACTION_FAILURE";

// Update Dunning Event Action
export const UPDATE_DUNNING_EVENT_ACTION = "UPDATE_DUNNING_EVENT_ACTION";
export const UPDATE_DUNNING_EVENT_ACTION_SUCCESS =
  "UPDATE_DUNNING_EVENT_ACTION_SUCCESS";
export const UPDATE_DUNNING_EVENT_ACTION_FAILURE =
  "UPDATE_DUNNING_EVENT_ACTION_FAILURE";

// Delete Dunning Event Action
export const DELETE_DUNNING_EVENT_ACTION = "DELETE_DUNNING_EVENT_ACTION";
export const DELETE_DUNNING_EVENT_ACTION_SUCCESS =
  "DELETE_DUNNING_EVENT_ACTION_SUCCESS";
export const DELETE_DUNNING_EVENT_ACTION_FAILURE =
  "DELETE_DUNNING_EVENT_ACTION_FAILURE";

///dunninglocktype/list
export const GET_DUNNING_LOCK_TYPE_LIST = "GET_DUNNING_LOCK_TYPE_LIST";
export const GET_DUNNING_LOCK_TYPE_LIST_SUCCESS =
  "GET_DUNNING_LOCK_TYPE_LIST_SUCCESS";
export const GET_DUNNING_LOCK_TYPE_LIST_FAILURE =
  "GET_DUNNING_LOCK_TYPE_LIST_FAILURE";
///dunninglocktype/data
export const GET_DUNNING_LOCK_TYPE_DATA = "GET_DUNNING_LOCK_TYPE_DATA";
export const GET_DUNNING_LOCK_TYPE_DATA_SUCCESS =
  "GET_DUNNING_LOCK_TYPE_DATA_SUCCESS";
export const GET_DUNNING_LOCK_TYPE_DATA_FAILURE =
  "GET_DUNNING_LOCK_TYPE_DATA_FAILURE";
///dunninglocktype/create
export const CREATE_DUNNING_LOCK_TYPE = "CREATE_DUNNING_LOCK_TYPE";
export const CREATE_DUNNING_LOCK_TYPE_SUCCESS =
  "CREATE_DUNNING_LOCK_TYPE_SUCCESS";
export const CREATE_DUNNING_LOCK_TYPE_FAILURE =
  "CREATE_DUNNING_LOCK_TYPE_FAILURE";
///dunninglocktype/update
export const UPDATE_DUNNING_LOCK_TYPE = "UPDATE_DUNNING_LOCK_TYPE";
export const UPDATE_DUNNING_LOCK_TYPE_SUCCESS =
  "UPDATE_DUNNING_LOCK_TYPE_SUCCESS";
export const UPDATE_DUNNING_LOCK_TYPE_FAILURE =
  "UPDATE_DUNNING_LOCK_TYPE_FAILURE";
///dunninglocktype/delete
export const DELETE_DUNNING_LOCK_TYPE = "DELETE_DUNNING_LOCK_TYPE";
export const DELETE_DUNNING_LOCK_TYPE_SUCCESS =
  "DELETE_DUNNING_LOCK_TYPE_SUCCESS";
export const DELETE_DUNNING_LOCK_TYPE_FAILURE =
  "DELETE_DUNNING_LOCK_TYPE_FAILURE";
///dunninglock/list
export const GET_DUNNING_LOCK_LIST = "GET_DUNNING_LOCK_LIST";
export const GET_DUNNING_LOCK_LIST_SUCCESS = "GET_DUNNING_LOCK_LIST_SUCCESS";
export const GET_DUNNING_LOCK_LIST_FAILURE = "GET_DUNNING_LOCK_LIST_FAILURE";
///dunninglock/data
export const GET_DUNNING_LOCK_DATA = "GET_DUNNING_LOCK_DATA";
export const GET_DUNNING_LOCK_DATA_SUCCESS = "GET_DUNNING_LOCK_DATA_SUCCESS";
export const GET_DUNNING_LOCK_DATA_FAILURE = "GET_DUNNING_LOCK_DATA_FAILURE";
///dunninglock/create
export const CREATE_DUNNING_LOCK = "CREATE_DUNNING_LOCK";
export const CREATE_DUNNING_LOCK_SUCCESS = "CREATE_DUNNING_LOCK_SUCCESS";
export const CREATE_DUNNING_LOCK_FAILURE = "CREATE_DUNNING_LOCK_FAILURE";
///dunninglock/update
export const UPDATE_DUNNING_LOCK = "UPDATE_DUNNING_LOCK";
export const UPDATE_DUNNING_LOCK_SUCCESS = "UPDATE_DUNNING_LOCK_SUCCESS";
export const UPDATE_DUNNING_LOCK_FAILURE = "UPDATE_DUNNING_LOCK_FAILURE";
///dunninglock/delete
export const DELETE_DUNNING_LOCK = "DELETE_DUNNING_LOCK";
export const DELETE_DUNNING_LOCK_SUCCESS = "DELETE_DUNNING_LOCK_SUCCESS";
export const DELETE_DUNNING_LOCK_FAILURE = "DELETE_DUNNING_LOCK_FAILURE";
///dunningprofile/list
export const GET_DUNNING_PROFILE_LIST = "GET_DUNNING_PROFILE_LIST";
export const GET_DUNNING_PROFILE_LIST_SUCCESS =
  "GET_DUNNING_PROFILE_LIST_SUCCESS";
export const GET_DUNNING_PROFILE_LIST_FAILURE =
  "GET_DUNNING_PROFILE_LIST_FAILURE";
///dunningprofile/data
export const GET_DUNNING_PROFILE_DATA = "GET_DUNNING_PROFILE_DATA";
export const GET_DUNNING_PROFILE_DATA_SUCCESS =
  "GET_DUNNING_PROFILE_DATA_SUCCESS";
export const GET_DUNNING_PROFILE_DATA_FAILURE =
  "GET_DUNNING_PROFILE_DATA_FAILURE";
///dunningprofile/create
export const CREATE_DUNNING_PROFILE = "CREATE_DUNNING_PROFILE";
export const CREATE_DUNNING_PROFILE_SUCCESS = "CREATE_DUNNING_PROFILE_SUCCESS";
export const CREATE_DUNNING_PROFILE_FAILURE = "CREATE_DUNNING_PROFILE_FAILURE";
///dunningprofile/update
export const UPDATE_DUNNING_PROFILE = "UPDATE_DUNNING_PROFILE";
export const UPDATE_DUNNING_PROFILE_SUCCESS = "UPDATE_DUNNING_PROFILE_SUCCESS";
export const UPDATE_DUNNING_PROFILE_FAILURE = "UPDATE_DUNNING_PROFILE_FAILURE";
///dunningprofile/delete
export const DELETE_DUNNING_PROFILE = "DELETE_DUNNING_PROFILE";
export const DELETE_DUNNING_PROFILE_SUCCESS = "DELETE_DUNNING_PROFILE_SUCCESS";
export const DELETE_DUNNING_PROFILE_FAILURE = "DELETE_DUNNING_PROFILE_FAILURE";
///dunningprofilestep/list
export const GET_DUNNING_PROFILE_STEP_LIST = "GET_DUNNING_PROFILE_STEP_LIST";
export const GET_DUNNING_PROFILE_STEP_LIST_SUCCESS =
  "GET_DUNNING_PROFILE_STEP_LIST_SUCCESS";
export const GET_DUNNING_PROFILE_STEP_LIST_FAILURE =
  "GET_DUNNING_PROFILE_STEP_LIST_FAILURE";
///dunningprofilestep/data
export const GET_DUNNING_PROFILE_STEP_DATA = "GET_DUNNING_PROFILE_STEP_DATA";
export const GET_DUNNING_PROFILE_STEP_DATA_SUCCESS =
  "GET_DUNNING_PROFILE_STEP_DATA_SUCCESS";
export const GET_DUNNING_PROFILE_STEP_DATA_FAILURE =
  "GET_DUNNING_PROFILE_STEP_DATA_FAILURE";
///dunningprofilestep/create
export const CREATE_DUNNING_PROFILE_STEP = "CREATE_DUNNING_PROFILE_STEP";
export const CREATE_DUNNING_PROFILE_STEP_SUCCESS =
  "CREATE_DUNNING_PROFILE_STEP_SUCCESS";
export const CREATE_DUNNING_PROFILE_STEP_FAILURE =
  "CREATE_DUNNING_PROFILE_STEP_FAILURE";
///dunningprofilestep/update
export const UPDATE_DUNNING_PROFILE_STEP = "UPDATE_DUNNING_PROFILE_STEP";
export const UPDATE_DUNNING_PROFILE_STEP_SUCCESS =
  "UPDATE_DUNNING_PROFILE_STEP_SUCCESS";
export const UPDATE_DUNNING_PROFILE_STEP_FAILURE =
  "UPDATE_DUNNING_PROFILE_STEP_FAILURE";
///dunningprofilestep/delete
export const DELETE_DUNNING_PROFILE_STEP = "DELETE_DUNNING_PROFILE_STEP";
export const DELETE_DUNNING_PROFILE_STEP_SUCCESS =
  "DELETE_DUNNING_PROFILE_STEP_SUCCESS";
export const DELETE_DUNNING_PROFILE_STEP_FAILURE =
  "DELETE_DUNNING_PROFILE_STEP_FAILURE";
